import Layout from "./Layout";
import "./styles/output.css";

function App() {
    return <Layout />;
}

export default App;
